import { ItemExpireContext as MessageExpireContext, MessageMetaRoot } from '@halo/ui-chat-react';
import type { Session } from '@halo/chat-sdk-react';
import { Center } from '@chakra-ui/react';
import {
  MsgAvatar,
  MsgBody,
  MsgBubble,
  MsgExpireAnimate,
  MsgHeader,
  MsgItem,
  MsgReadStatus,
} from '../../msg-parts';
import type { MsgUnknownContentProps } from './msg-unknown-content';
import { MsgUnknownContent } from './msg-unknown-content';

export interface MsgUnknownProps extends MsgUnknownContentProps {
  session: Session;
}

export const MsgUnknown = memo(function MsgUnknown({ session, message }: MsgUnknownProps) {
  return (
    <MsgItem message={message}>
      <MessageExpireContext message={message}>
        <MsgAvatar message={message} session={session} />
        <MsgBody message={message}>
          <MsgHeader message={message} session={session} />
          <MsgExpireAnimate session={session} message={message}>
            <MsgBubble message={message}>
              <MsgUnknownContent message={message}></MsgUnknownContent>
              <MessageMetaRoot>
                <Center marginLeft="auto" gap="1.5">
                  <MsgReadStatus message={message} session={session} />
                </Center>
              </MessageMetaRoot>
            </MsgBubble>
          </MsgExpireAnimate>
        </MsgBody>
      </MessageExpireContext>
    </MsgItem>
  );
});
